import { render, staticRenderFns } from "./FeedbackSurvey.vue?vue&type=template&id=a2f9ef64&scoped=true&"
import script from "./FeedbackSurvey.vue?vue&type=script&lang=js&"
export * from "./FeedbackSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f9ef64",
  null
  
)

export default component.exports